import Markdown from "markdown-to-jsx";
import Image from "next/image";
import styles from "./missaoCompromisso.module.css";

export default function Porque({ data }) {
  return (
    <section
      className={`container-full ${styles.container}`}
      style={{
        backgroundImage: `url(${data.background_imagem.url})`,
        backgroundRepeat: "no-repeat, repeat",
        backgroundSize: "contain",
        backgroundPosition: "-150px",
        backgroundColor: "#002C44",
      }}
    >
      {/* <div className={styles.placeholder} /> */}
      <div className={`flex-column flex-lg-row ${styles.content}`}>
        <div className={styles.bgImg}>
          {/* <Image
            src={data.background_imagem.url}
            width={933}
            height={662}
            objectFit="contain"
            responsive
          /> */}
        </div>
        <div className={styles.infoContent}>
          <div className={styles.logos_img}>
            <img
              src={data.logos.logo_programa.url}
              alt="logo Minha Casa Minha Vida"
              objectFit="contain"
            />
            <img
              src={data.logos.logo_caixa.url}
              alt="logo caixa"
              objectFit="contain"
            />
          </div>
          <div className={styles.title}>
            <div className={styles.parallelogramDetail} />
            <h2>{data.title}</h2>
          </div>
          <div className={styles.listItems}>
            <ul>
              {data.itens.map((item, index) => {
                return <li>{item.text}</li>;
              })}
            </ul>
          </div>
        </div>

        {/* <img src={data.imagem.url} />
        <div className={styles.contentText}>
          <div className={styles.title}>
            <div className={styles.parallelogramDetail} />
            <h1>{data.titulo}</h1>
          </div>
          <Markdown>{data.texto}</Markdown>
        </div> */}
      </div>
    </section>
  );
}
